import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ANSWERS_DATA } from "./correctAnswerDatas";

function KeywordCheck({ onWrong, answerData }) {
  const [value, setValue] = useState("");
  const navigate = useNavigate();

  const KEYWORD_DATA = ANSWERS_DATA.keyword[0];
  const handleSubmit = () => {
    const key = value.trim().toLowerCase();
    const keywordInfo = KEYWORD_DATA[key];
    if (!KEYWORD_DATA[key]) {
      onWrong();
      return;
    }

    if (keywordInfo) {
      navigate("/quiz", {
        state: {
          answerDataState: keywordInfo.answerData,
          DateValState: keywordInfo.DateVal,
          titImgclassNameState: keywordInfo.titImgclassName,
          hintWhetherIsState: keywordInfo.hintWhetherIs,
          hintContentState: keywordInfo.hintContent,
        },
      });
      //console.log(KEYWORD_DATA[key]);
    }
  };
  return (
    <div className="mt24 mb40">
      <input
        className="input01"
        placeholder="키워드를 입력하세요."
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <button className="inputBtn01 mt16" onClick={handleSubmit}>
        입력 완료
      </button>
    </div>
  );
}

export default KeywordCheck;
